import React, { useEffect, useState } from 'react';
import StakeBox from './StakeBox';
import ActivatedBox from './ActivatedBox';
import { useContextData } from '../../../core/context';
import Config from "../../../core/config";
import { makeRequest } from '../../../core/services/v1/request';
import TransferModalEarn from '../TransferModalEarn';
import { Spinner } from 'react-bootstrap';

const EarnIndex = ({ fundMoveUSDT, fundUSDTLoading, tab, isPre = false }) => {
    const { earnBalance, earnUsdtLoading, setEarnUsdtBalance, myProfile } = useContextData();
    const [loading, setLoading] = useState(true);
    const [spotWalletData, setSpotWalletData] = useState([]);
    useEffect(() => {
        setEarnUsdtBalance()
        getSpotWalletCurrency()
    }, [])

    async function getSpotWalletCurrency() {
        setLoading(true);
        const params = {
            url: `${Config.V2_API_URL}wallet/getSpotHoldings?search=usdt`,
            method: 'GET'
        };
        const response = await makeRequest(params);

        if (response) {
            const {
                data = [],
            } = response;
            setSpotWalletData(data);
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
        else {
            setSpotWalletData([]);
            setTimeout(() => {
                setLoading(false);
            }, 2000);
        }
    }
    return (
        <div className='mb-5 px-3'>
            <div className='box-balance mt-2'>
                <div>
                    <h5 style={{ fontSize: "18px" }}>Earn Balance: {earnUsdtLoading ? <Spinner aria-label="Spinner button example" size="sm" /> : (`$${earnBalance?.available}` || `$0.0`)}</h5>
                </div>
                <div>
                    <TransferModalEarn avl={spotWalletData?.[0]?.balance.toFixed(3) || 0} firstCurrency={spotWalletData?.[0]?.currencySymbol || 'USDT'} image={spotWalletData?.[0]?.image || 'https://assets.coingecko.com/coins/images/325/small/Tether-logo.png'} fundMoveUSDT={fundMoveUSDT} fundUSDTLoading={fundUSDTLoading} title={loading ? <Spinner aria-label="Spinner button example" size="sm" /> : "Add"} loading={loading} />
                </div>
            </div>
            {
                (myProfile?.isStake && tab == 6) || (myProfile?.isStake && isPre) ?
                    <div className='mt-4'>
                        <ActivatedBox />
                    </div> :
                    <div className='mt-4'>
                        <StakeBox />
                    </div>
            }

        </div>
    );
};

export default EarnIndex;